export const Loader = () => {
    return (
        <div className="flex flex-col items-center justify-center h-screen">
            <img
                className="w-8 h-8 animate-spin "
                src="/logo.png"
                alt="spinner"
            />
        </div>
    );
};
